var screenHeightToBlockHeight = function() {
    var screenHeight = jQuery(window).height();

    jQuery('[data-screen-height]').height(screenHeight);
}

export {
    screenHeightToBlockHeight
};